import { FeaturedArticlesFragmentFragment } from '../../../__generated__/graphql';

export const getCategoryLookup = (featuredArticles: FeaturedArticlesFragmentFragment[]) =>
  featuredArticles.reduce<Record<number, string[]>>((acc, article): Record<number, string[]> => {
    // the initial set of featured articles doesn't have a category, so we use 0 instead
    const categoryIds = article.category?.edges.map(edge => edge.node.databaseId) ?? [0];
    for (const id of categoryIds) {
      const ids = (article.articles ?? []).flatMap(art =>
        (art?.article?.edges ?? []).reduce<string[]>((accu, edge): string[] => {
          if (edge.node.__typename === 'Post') {
            return [...accu, edge.node.id];
          }

          return accu;
        }, []));

      const existingCategory = acc[id];
      if (existingCategory) {
        acc[id] = Array.from(new Set([...existingCategory, ...ids]));
      }
      else {
        acc[id] = ids;
      }
    }

    return acc;
  }, {});
